module.exports = __webpack_public_path__ + "media/metronic/_theme/media/blog/blog5-7b2d082763debd0e0c34a039f57049a0.jpg";